
import { Component, Prop, Vue, Emit } from 'vue-property-decorator'
import FieldContainer from './FieldContainer.vue'
@Component({
  components: {
    FieldContainer
  }
})
export default class DatePickerField extends Vue {
  @Prop({ default: '' }) value!: string
  @Prop({ default: '' }) error!: string
  @Prop({ default: null }) label!: string
  @Prop({ default: false }) required!: boolean
  @Prop({ default: false }) readOnly!: boolean
  @Prop({ default: false }) isDisabled!: boolean
  @Prop({ default: '' }) hintHtml!: string

  @Emit('input')
  updateValue(newValue: string) {
    return newValue
  }
}
